<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()
const isAuthenticated = computed(() => authStore.isAuthenticated)
const user = computed(() => authStore.user)

async function handleLogout() {
  await authStore.logout()
  router.push('/')
}
</script>

<template>
  <header class="bg-white shadow-sm border-b border-navy-100">
    <nav class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16 items-center">
        <RouterLink to="/" class="flex items-center space-x-2">
          <span class="text-xl font-bold text-navy-700">DCAD Monitor</span>
          <span class="text-xs bg-amber-500 text-white px-1.5 py-0.5 rounded-full font-semibold uppercase tracking-wide">Beta</span>
        </RouterLink>
        <div class="flex items-center space-x-4">
          <template v-if="isAuthenticated">
            <RouterLink to="/dashboard" class="text-gray-700 hover:text-navy-600 transition-colors">
              Dashboard
            </RouterLink>
            <span class="text-gray-400">|</span>
            <span class="text-gray-600 text-sm">{{ user?.email }}</span>
            <button class="btn btn-secondary text-sm" @click="handleLogout">Logout</button>
          </template>
          <template v-else>
            <RouterLink to="/login" class="text-gray-700 hover:text-navy-600 transition-colors">Login</RouterLink>
            <RouterLink to="/register" class="btn btn-primary">Get Started</RouterLink>
          </template>
        </div>
      </div>
    </nav>
  </header>
</template>
